export class DisplayMode {
  constructor(node) {
    this.rootElement = node;
    this.resultContainer = this.rootElement.closest('#downloadList').querySelector('.c-downloads-list__container');
    this.gridButton = this.rootElement.querySelector('[data-gs1-display-mode-button-grid]');
    this.listButton = this.rootElement.querySelector('[data-gs1-display-mode-button-list]');
    this.gridButton.addEventListener('click', this.onButtonClick.bind(this));
    this.listButton.addEventListener('click', this.onButtonClick.bind(this));

    if (sessionStorage.getItem('gs1-media-hub-display-mode') && sessionStorage.getItem('gs1-media-hub-display-mode') === 'list' && !this.resultContainer.classList.contains('c-downloads-list__container--style-list')) {
      this.resultContainer.classList.add('c-downloads-list__container--style-list');
    }
  }

  onButtonClick(event) {
    const el = event.target;
    const downloadList = el.closest('#downloadList');
    const resultContainer = downloadList.querySelector('.c-downloads-list__container');

    if (el.closest('button').hasAttribute('data-gs1-display-mode-button-list') && !resultContainer.classList.contains('c-downloads-list__container--style-list')) {
      resultContainer.classList.add('c-downloads-list__container--style-list');
      sessionStorage.setItem('gs1-media-hub-display-mode', 'list');
      this.listButton.setAttribute('aria-pressed', 'true');
      this.gridButton.setAttribute('aria-pressed', 'false');
    }

    if (el.closest('button').hasAttribute('data-gs1-display-mode-button-grid') && resultContainer.classList.contains('c-downloads-list__container--style-list')) {
      resultContainer.classList.remove('c-downloads-list__container--style-list');
      sessionStorage.setItem('gs1-media-hub-display-mode', 'grid');
      this.listButton.setAttribute('aria-pressed', 'false');
      this.gridButton.setAttribute('aria-pressed', 'true');
    }
  }
}

const displayMode = document.querySelectorAll('[data-gs1-display-mode]');
displayMode.forEach((mode) => {
  new DisplayMode(mode);
});
